// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"200aff52","367":"0870380c","396":"6d858a3a","865":"7c59c257"}[chunkId] + ".chunk.css";
};